import { FilterValue } from "./search";

export enum FieldTypes {
  text = "text",
  textArea = "textarea",
  email = "email",
  tel = "tel",
  select = "select",
  checkbox = "checkbox",
  singleCheckbox = "singleCheckbox",
  search = "search",
  hidden = "hidden",
}

export interface Field {
  label: string;
  id: string;
  name: string;
  type?: FieldTypes;
  options?: FilterValue[];
  value?: string;
  placeholder?: string;
  required?: boolean;
  conditional?: string;
  disabled?: boolean;
}
